// @ts-strict-ignore
import { useState, useEffect } from 'react';

export default function useWindowSize(debounce = 0) {
    const [windowSize, setWindowSize] = useState({
        width: window.innerWidth,
        height: window.innerHeight,
    });

    useEffect(() => {
        let timeout: NodeJS.Timeout;
        const onResize = () => {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                setWindowSize({
                    width: window.innerWidth,
                    height: window.innerHeight,
                });
            }, debounce);
        };

        window.addEventListener('resize', onResize);
        return () => {
            clearTimeout(timeout);
            window.removeEventListener('resize', onResize);
        };
    }, [debounce]);

    return windowSize;
}
